import { getJsonList } from '../services/json-service.js';
import { renderDeviceView, renderPackingView, type ToolkitItem } from '../render/road-warrior-kit.js';
import { renderFilterChips } from '../ui/filter-chips.js';
import { hasPrerenderedMarkup, whenIdle } from '../ui/lazy-hydrate.js';
import { initLayout } from '../layout.js';

function initRoadWarriorKitPage(): void {
  const viewFilters = document.getElementById('toolkit-view-filters');
  const categoryFilters = document.getElementById('toolkit-category-filters');
  const content = document.getElementById('toolkit-content');
  if (!viewFilters || !categoryFilters || !content) return;

  let allItems: ToolkitItem[] = [];
  let selectedView = 'Packing Category';
  let selectedCategory = '1 Minimalist';
  const keepPrerender = hasPrerenderedMarkup(content);

  const render = (updateContent = true) => {
    if (selectedView === 'Packing Category') {
      categoryFilters.style.display = '';
      if (updateContent) {
        content.innerHTML = renderPackingView(allItems, selectedCategory);
      }
      renderFilterChips({
        container: categoryFilters,
        options: [...new Set(allItems.flatMap((item) => item.Categories))].sort(),
        selected: selectedCategory,
        showAll: false,
        onSelect: (chip) => {
          selectedCategory = chip;
          render(true);
        },
        ariaLabel: 'Packing category',
      });
    } else {
      categoryFilters.style.display = 'none';
      if (updateContent) {
        content.innerHTML = renderDeviceView(allItems);
      }
    }

    renderFilterChips({
      container: viewFilters,
      options: ['Packing Category', 'Device Type'],
      selected: selectedView,
      showAll: false,
      onSelect: (view) => {
        selectedView = view;
        render(true);
      },
      ariaLabel: 'View mode',
    });
  };

  whenIdle(() => {
    void (async () => {
      allItems = await getJsonList<ToolkitItem>('roadWarriorKit.json', 'title');
      selectedCategory = '1 Minimalist';
      render(!keepPrerender);
    })();
  });
}

initLayout();
initRoadWarriorKitPage();
